import { useState, useEffect } from 'react';
import { useGetAllAiMediaData } from '../../services';
import { AIMedia, UploadTypes } from '../../@types';
import { useGetFiniteAiMediaData } from '../../../t2c-fe/services/ai-generate/getAllAiMediaData';

interface PaginatedAiMediaDataPayload {
  type: UploadTypes;
  shouldFetchData: boolean;
}

export const usePaginatedAiMediaData = ({ type, shouldFetchData }: PaginatedAiMediaDataPayload) => {
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [searchQuery, setSearchQuery] = useState<string>('');
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState<string>('');

  const {
    data: aiMediaData,
    isLoading: isLoadingAiMediaData,
    refetch: refetchAiMediaData,
    isFetching: isFetchingAiMediaData,
  } = useGetFiniteAiMediaData({
    type,
    shouldFetchData,
    name: debouncedSearchQuery,
    limit: itemsPerPage,
  });

  const hasMoreAiMediaData = aiMediaData?.length === itemsPerPage;

  const fetchNextPageAiMediaData = () => {
    if (hasMoreAiMediaData && !isLoadingAiMediaData && !isFetchingAiMediaData) {
      setItemsPerPage((prev) => prev + 10);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery.trim());
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  return {
    aiMediaData,
    isLoadingAiMediaData,
    isFetchingAiMediaData,
    refetchAiMediaData,
    fetchNextPageAiMediaData,
    hasMoreAiMediaData,
    setSearchQuery,
  };
};
